import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import CustomFormInput from '../CustomFormInput'
import { SkillValidation } from '../../validate/skillValidation';
import ErrorFilter from '../../helper/errorFilter';
import { addCategoryList, editCategoryList } from '../../controller';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { requestHandler } from '../../helper';
import SingleError from '../../helper/SingleError';

function AddCategoryModal({ show, getCategoryData, setShowCat, categoryData, id, setId, setSelectedCat, page }) {

  const requiredField = ["title"];
  const [errors, setErrors] = useState({});

  const [submitCount, setSubmitCount] = useState(0);
  // const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const handleClose = () => {

    setId(null);
    setSelectedCat({})
    setShowCat(false);
    if (!categoryData) {
      setCategory({ title: "" });
    }
    setErrors({});
  }
  const [category, setCategory] = useState({
    title: categoryData?.title || "",
  })

  useEffect(() => {
    if (categoryData) {
      setCategory({
        title: categoryData.title,
      });
    }
    // eslint-disable-next-line
  }, [categoryData]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (submitCount > 0) {
      let validationError = SkillValidation({
        ...category,
        [name]: value
      });
      validationError = ErrorFilter(validationError, requiredField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
    }
    setCategory({ ...category, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updateValues = { ...category };
    let validationErrors = SkillValidation(updateValues);
    validationErrors = ErrorFilter(validationErrors, requiredField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {

      await requestHandler(
        async () => {
          if (id) {
            return await editCategoryList(updateValues, id);
          } else {
            return await addCategoryList(updateValues);
          }
        },
        null,
        (res) => {
          toast.success(res.message);
          navigate("/category-management");
          getCategoryData(page);
          handleClose();
        },
        () => { }
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>{categoryData?._id ? "Edit Category" : "Add Category"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomFormInput
          type="text"
          label="Category Title"
          placeholder="Enter category title"
          id="title"
          name="title"
          value={categoryData?._id && category.title}
          onChange={handleChange}
        />
        <SingleError error={errors.title} />
        <div className="d-sm-flex align-items-center gap-sm-4 gap-2">
          <button onClick={handleClose} className="btn btn-outline-light w-100">
            Cancel
          </button>
          <button className="btn btn-primary w-100 mt-sm-0 mt-2" type="button" onClick={handleSave}>
            {categoryData ? "Save Changes" : "Add Category"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AddCategoryModal